<main class="bg-black text-white min-h-screen overflow-x-hidden">
  <section class="relative min-h-[65vh] flex items-center pt-24 pb-14 overflow-hidden page-hero-gradient">
    <div class="absolute -top-48 right-0 w-[700px] h-[700px] bg-varroc-accent/5 rounded-full blur-3xl"></div>
    <div class="relative z-10 max-w-7xl mx-auto px-6 w-full">
      <div class="max-w-3xl">
        <a routerLink="/solutions/business" class="back-nav" data-aos="fade-down">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4 svg-stroke-gradient"><polyline points="15 18 9 12 15 6"></polyline></svg>
          Back
        </a>
        <h1 class="hero-col font-black mb-5" data-aos="fade-up" data-aos-delay="100">
          Insurance <span class="text-varroc-accent">BFSI</span> Solutions
        </h1>
        <p class="text-varroc-text-gray text-lg leading-relaxed mb-8 max-w-2xl" data-aos="fade-up" data-aos-delay="200">
          Real-time usage-based insurance, automated FNOL, and fraud detection — powered by connected vehicle data and AI to transform motor insurance underwriting and claims.
        </p>
        <div class="flex flex-wrap gap-4" data-aos="fade-up" data-aos-delay="300">
          <a routerLink="/contact-us" class="bg-varroc-accent text-white font-bold px-8 py-4 rounded-md hover:bg-varroc-accent-hover hover:shadow-neon transition-all">Request a Demo</a>
          <a routerLink="/resources" class="border border-varroc-accent/40 font-semibold px-8 py-4 rounded-md hover:border-varroc-accent hover:bg-varroc-accent/10 transition-all">Case Studies</a>
        </div>
      </div>
    </div>
  </section>
  <nav class="sticky-product-nav">
    <div class="max-w-7xl mx-auto px-6">
      <div class="flex overflow-x-auto">
        <a *ngFor="let s of sections" (click)="scrollTo(s.id)" [class.active]="activeSection === s.id" class="cursor-pointer flex-shrink-0">
          <i class='bx text-base' [class]="s.icon"></i> {{ s.label }}
        </a>
      </div>
    </div>
  </nav>
  <div class="max-w-7xl mx-auto px-6 py-20 space-y-28">
    <section id="overview" class="section-anchor">
      <div class="text-center mb-12" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Overview</span>
        <h2 class="text-4xl font-black mt-2 mb-4">Connected Intelligence for Insurers</h2>
        <p class="text-varroc-text-gray text-lg max-w-2xl mx-auto">Replace actuarial assumptions with real driving data — enabling fair, dynamic, and profitable motor insurance products.</p>
      </div>
      <div class="grid md:grid-cols-3 gap-5">
        <div *ngFor="let m of metrics" class="feature-card text-center">
          <div class="text-varroc-accent font-black text-3xl mb-1">{{ m.val }}</div>
          <div class="text-varroc-text-gray text-sm">{{ m.label }}</div>
        </div>
      </div>
    </section>
    <div class="accent-divider"></div>
    <section id="features" class="section-anchor">
      <div class="text-center mb-12" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Capabilities</span>
        <h2 class="text-4xl font-black mt-2 mb-4">Insurance & BFSI Features</h2>
      </div>
      <div class="grid md:grid-cols-3 gap-6">
        <div *ngFor="let f of features; let i = index" class="feature-card" [attr.data-aos]="'fade-up'" [attr.data-aos-delay]="(i * 80).toString()">
          <div class="w-11 h-11 bg-varroc-accent/15 rounded-xl flex items-center justify-center mb-4">
            <i class='bx icon-gradient text-xl' [class]="f.icon"></i>
          </div>
          <h3 class="text-white font-bold mb-2">{{ f.title }}</h3>
          <p class="text-varroc-text-gray text-sm leading-relaxed">{{ f.desc }}</p>
        </div>
      </div>
    </section>
    <!-- <div class="accent-divider"></div>
    <section id="outcomes" class="section-anchor">
      <div class="feature-card p-10 text-center" data-aos="fade-up">
        <p class="text-varroc-text-gray text-lg mb-6">Ready to modernise your motor insurance with connected vehicle data?</p>
        <a routerLink="/contact-us" class="inline-block bg-varroc-accent text-white font-bold px-10 py-4 rounded-md hover:bg-varroc-accent-hover hover:shadow-neon transition-all">Talk to Our BFSI Team</a>
      </div>
    </section> -->
  </div>
</main>
